import { useFrame as r } from "@studio-freight/hamo";
import e from "@studio-freight/lenis";
import t from "clsx";
import n, { createContext as o, useEffect as l, forwardRef as a, useRef as c, useState as s, useCallback as i, useImperativeHandle as u, useContext as f } from "react";
import { create as p } from "zustand";
"function" == typeof SuppressedError && SuppressedError;
"undefined" != typeof window && (window.reactLenisVersion = "0.0.47");
const d = o(null),
  m = p(() => ({}));
function b(r, e = [], t = 0) {
  const {
    lenis: n,
    addCallback: o,
    removeCallback: a
  } = function () {
    const r = f(d),
      e = m();
    return null != r ? r : e;
  }();
  return l(() => {
    if (r && o && a && n) return o(r, t), r(n), () => {
      a(r);
    };
  }, [n, o, a, t, ...e]), n;
}
const y = a((o, a) => {
  var {
      children: f,
      root: p = !1,
      options: b = {},
      autoRaf: y = !0,
      rafPriority: v = 0,
      className: O
    } = o,
    g = function (r, e) {
      var t = {};
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
      if (null != r && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for (n = Object.getOwnPropertySymbols(r); o < n.length; o++) e.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[o]) && (t[n[o]] = r[n[o]]);
      }
      return t;
    }(o, ["children", "root", "options", "autoRaf", "rafPriority", "className"]);
  const h = c(null),
    w = c(null),
    [k, N] = s(void 0),
    j = c([]),
    C = i((r, e) => {
      j.current.push({
        callback: r,
        priority: e
      }), j.current.sort((r, e) => r.priority - e.priority);
    }, []),
    E = i(r => {
      j.current = j.current.filter(e => e.callback !== r);
    }, []);
  u(a, () => ({
    wrapper: h.current,
    content: w.current,
    lenis: k
  }), [k]), l(() => {
    const r = new e(Object.assign(Object.assign({}, b), !p && {
      wrapper: h.current,
      content: w.current
    }));
    return N(r), () => {
      r.destroy(), N(void 0);
    };
  }, [p, JSON.stringify(b)]), r(r => {
    y && (null == k || k.raf(r));
  }, v), l(() => {
    p && k && m.setState({
      lenis: k,
      addCallback: C,
      removeCallback: E
    });
  }, [p, k, C, E]);
  const P = i(r => {
    for (let e = 0; e < j.current.length; e++) j.current[e].callback(r);
  }, []);
  l(() => (null == k || k.on("scroll", P), () => {
    null == k || k.off("scroll", P);
  }), [k, P]);
  const S = i(() => {
    h.current && (h.current.className = t(null == k ? void 0 : k.className, O));
  }, [k, O]);
  return l(() => (S(), null == k || k.on("className change", S), () => {
    null == k || k.off("className change", S);
  }), [k, S]), n.createElement(d.Provider, {
    value: {
      lenis: k,
      addCallback: C,
      removeCallback: E
    }
  }, p ? f : n.createElement("div", Object.assign({
    ref: h,
    className: t(null == k ? void 0 : k.className, O)
  }, g), n.createElement("div", {
    ref: w
  }, f)));
});
export { y as Lenis, d as LenisContext, y as ReactLenis, y as default, b as useLenis };